export class Response {
    public message: string;

    constructor(inMessage: string) {
        this.message = inMessage;
    }
}
